import React from "react";
import { Button, Switch, message } from "antd";
import ReminderModal from "./ReminderModal";
import coparent from "../../Assets/EmailCapture/email-icon.png";
const URL = process.env.REACT_APP_API_URL;
const StepFour = ({
  notificationSettings,
  setNotificationSettings,
  reminder,
  modalVisible,
  setModalVisible,
  handleSaveReminder,
  skipAndClose,
}) => {
  // console.log("StepFour notificationSettings", notificationSettings);
  function minutesToDHMS(totalMinutes) {
    const days = Math.floor(totalMinutes / (24 * 60));
    const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
    const minutes = totalMinutes % 60;
    return { days, hours, minutes };
  }
  const reminder1 = minutesToDHMS(
    Number(notificationSettings?.reminderEnabled || 0)
  );
  const saveNotification = async (skipped = false) => {
    try {
      const token = localStorage.getItem("authToken");

      const payload = {
        notification_setup_status: skipped
          ? "skipped_and_use_default_settings"
          : "completed",
        ...(skipped
          ? {}
          : {
              is_push_notification_enabled: notificationSettings.push,
              is_email_summaries_enabled: notificationSettings.email,
              is_calendar_sync_enabled: notificationSettings.calendar,
              reminder_offset: notificationSettings.reminderEnabled || 0,
            }),
      };

      const response = await fetch(
        `${URL}/v1/email-assistant/notification-setup`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (!response.ok)
        throw new Error(result.message || "Something went wrong");

      message.success(result.message || "Notification settings saved.");
      // You can close modal or go to next step here
    } catch (error) {
      console.error("Notification save error:", error);
      message.error(error.message || "Failed to save notification settings.");
    }

    skipAndClose();
  };

  return (
    <div className="modal-content">
      <h2 className="modal-title-step2">Stay Notified</h2>
      <img src={coparent} width={180} style={{ marginBottom: "10px" }} />

      <div className="switch-selection">
        <div className="btn-switch">
          <div style={{ paddingBottom: "5px" }}>Push Notifications</div>
          <div style={{ paddingBottom: "5px" }}>
            <Switch
              checked={notificationSettings.push === 1}
              onChange={(checked) =>
                setNotificationSettings({
                  ...notificationSettings,
                  push: checked ? 1 : 0,
                })
              }
            />
          </div>
        </div>

        <div className="btn-switch">
          <div style={{ paddingBottom: "5px" }}>Email Summaries</div>
          <div style={{ paddingBottom: "5px" }}>
            <Switch
              checked={notificationSettings.email === 1}
              onChange={(checked) =>
                setNotificationSettings({
                  ...notificationSettings,
                  email: checked ? 1 : 0,
                })
              }
            />
          </div>
        </div>

        <div className="btn-switch">
          <div style={{ paddingBottom: "5px" }}>Calendar Sync</div>
          <div style={{ paddingBottom: "5px" }}>
            <Switch
              checked={notificationSettings.calendar == 1}
              onChange={(checked) =>
                setNotificationSettings({
                  ...notificationSettings,
                  calendar: checked ? 1 : 0,
                })
              }
            />
          </div>
        </div>

        <div className="btn-switch">
          <div
            style={{ paddingBottom: "5px" }}
            onClick={() => setModalVisible(true)}
          >
            <p style={{ margin: "0px", fontSize: "18px", marginBottom: "5px" }}>
              Reminder Timing
            </p>
            <p style={{ margin: "0px", fontSize: "12px", color: "#767A83" }}>
              {notificationSettings.reminderEnabled
                ? notificationSettings.reminderEnabled === 60
                  ? "1 hour"
                  : notificationSettings.reminderEnabled === 1440
                  ? "1 day"
                  : `${notificationSettings.reminderEnabled} minute(s)`
                : "Not set"}
            </p>
          </div>
          <div style={{ paddingBottom: "5px" }}>
            <Switch
              checked={notificationSettings.reminderEnabled ? true : false}
              disabled={false} // Always enabled now
              onChange={(checked) => {
                if (checked) {
                  // ✅ Open modal when toggled ON
                  setModalVisible(true);

                  // if no previous value, set a temporary default (like 5 mins)
                  if (!notificationSettings.reminderEnabled) {
                    setNotificationSettings({
                      ...notificationSettings,
                      reminderEnabled: 5,
                    });
                  }
                } else {
                  // ✅ When toggled OFF → clear reminder
                  setNotificationSettings({
                    ...notificationSettings,
                    reminderEnabled: 0,
                  });
                }
              }}
            />
          </div>
        </div>
      </div>

      <ReminderModal
        show={modalVisible}
        onSave={(minutes) => {
          // save minutes directly
          setNotificationSettings({
            ...notificationSettings,
            reminderEnabled: minutes,
          });
        }}
        initialMinutes={notificationSettings?.reminderEnabled}
        onCancel={() => setModalVisible(false)}
        handleClose={() => setModalVisible(false)}
      />

      <Button
        type="primary"
        className="modal-btn"
        onClick={() => saveNotification(false)} // completed
        style={{ marginTop: "20px" }}
      >
        Finish Setup
      </Button>
      <Button
        className="modal-btn-skip"
        onClick={() => saveNotification(true)} // skipped_and_use_default_settings
        style={{ marginTop: "10px" }}
      >
        Skip & Use Default Settings
      </Button>
    </div>
  );
};

export default StepFour;
